<div [id]="chartId" style="width: 100%; height: 500px"></div>
